/**
 * LiveJoin (/live/:code) — the GUEST's entry. No account: reading the code from the
 * link is enough. It registers the room as guest, then steps into the workspace; the
 * host's sync_request reply immediately steers the guest to whatever screen the host
 * is on and hydrates the shared state.
 */
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useLiveRoom } from "../demo/live/LiveRoom";

export function LiveJoin() {
  const { code } = useParams<{ code: string }>();
  const navigate = useNavigate();
  const { startRoom } = useLiveRoom();

  useEffect(() => {
    if (!code) {
      navigate("/", { replace: true });
      return;
    }
    startRoom(code, "guest");
    // Land on a real screen; the host's sync reply corrects this to their current page.
    navigate("/dashboard", { replace: true });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [code]);

  return (
    <main className="mx-auto flex min-h-[calc(100dvh-2rem)] max-w-md flex-col items-center justify-center px-6 text-center">
      <div className="h-2 w-2 animate-pulse rounded-full bg-[var(--color-gold)]" />
      <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-[var(--color-text-muted)]">
        Joining the live demo…
      </p>
    </main>
  );
}
